import React, { useEffect, useRef } from 'react';
import { Container, Logo, ExternalLink } from '../components';
import { Link } from "gatsby";
import { FaFacebook } from "@react-icons/all-files/fa/FaFacebook";
import { BsTwitterX } from "react-icons/bs";
import { FaLinkedin } from "@react-icons/all-files/fa/FaLinkedin";
import { FaInstagram } from "@react-icons/all-files/fa/FaInstagram";
import { FaYoutube } from "@react-icons/all-files/fa/FaYoutube";
import { FaPhone } from "@react-icons/all-files/fa/FaPhone";
import { FaEnvelope } from "@react-icons/all-files/fa/FaEnvelope";

function Footer() {
    const trustpilotWidgetRef = useRef(null);
    useEffect(() => {
        // Function to attempt reinitialization of Trustpilot widgets
        const reinitializeTrustpilotWidgets = () => {
            if (window.Trustpilot && trustpilotWidgetRef.current) {
                window.Trustpilot.loadFromElement(trustpilotWidgetRef.current, true);
            }
        };

        // Observe the entire body for the addition of child elements if needed
        // You might not need a MutationObserver if you're just initializing once on component mount

        // Ensure Trustpilot widgets are reinitialized on initial load
        reinitializeTrustpilotWidgets();

        // Optionally, you might set up a MutationObserver or other logic here if you need to detect dynamic changes
    }, []);

    return (
        <footer className="bg-holborn-blue">
            <Container className="services">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 py-14 mx-auto">
                    <div className="col-span-full lg:col-start-2 lg:col-end-12">
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
                            <div className="footer-col-wrapper">
                                <h5 className="text-holborn-white" style={{ textDecoration: 'underline', textDecorationThickness: '2px', textUnderlineOffset: '5px' }}>
                                    Office Locations
                                </h5>
                                <div className="office-locations-wrapper pt-1">
                                    <div className="office-locations">
                                        <ul className="text-white">
                                            <li><p className='pb-1'>Holborn Wealth Management Spain S.L.</p></li>
                                            <li><p className='pb-1'>Lugar Puerta De Banus Centro Comercial</p></li>
                                            <li><p className='pb-1'>Nº., Localº, 38</p></li>
                                            <li><p className='pb-1'>29660 Nueva Andalucia, Malaga</p></li>
                                            <li><p className='pb-1'>Part of the Holborn Group LLC</p></li>
                                        </ul>
                                        <div className="contact-wrapper pt-6">
                                            <ul className='text-white'>
                                                <li className="flex">
                                                    <FaPhone className="mt-1" />
                                                    <p className="ml-2 pb-2">
                                                        <ExternalLink to="tel:+34951086120">
                                                            +34 951086120
                                                        </ExternalLink>
                                                    </p>
                                                </li>
                                                <li className="flex">
                                                <FaEnvelope className="mt-1" />
                                                    <p className="ml-2">
                                                        <ExternalLink to="mailto:info@holbornassets.com.es">
                                                            info@holbornassets.com.es
                                                        </ExternalLink>
                                                    </p>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="footer-col-wrapper">
                                <h5 className="text-holborn-white decoration-1" style={{ textDecoration: 'underline', textDecorationThickness: '2px', textUnderlineOffset: '5px' }}>
                                    Our Services
                                </h5>
                                <ul className="text-holborn-white text-sm leading-7">
                                    <li className="p-1 md:p-0">
                                        <Link to="/our-services/retirement-planning/">Retirement Planning</Link>
                                    </li>
                                    <li className="p-1 md:p-0">
                                        <Link to="/our-services/investments/">Investments</Link>
                                    </li>
                                    <li className="p-1 md:p-0">
                                        <Link to="/our-services/mortgage-property/">Mortgage Property</Link>
                                    </li>
                                    <li className="p-1 md:p-0">
                                        <Link to="/our-services/financial-planning/">Financial Planning</Link>
                                    </li>
                                    <li className="p-1 md:p-0">
                                        <Link to="/our-services/currency-transfers/">Currency Transfer</Link>
                                    </li>
                                    <li className="p-1 md:p-0">
                                        <Link to="/our-services/residency/">Residency</Link>
                                    </li>
                                    <li className="p-1 md:p-0">
                                        <Link to="/our-services/insurance/">Insurance</Link>
                                    </li>
                                    <li className="p-1 md:p-0">
                                        <Link to="/our-services/estate-planning/">Estate Planning</Link>
                                    </li>
                                    <li className="p-1 md:p-0">
                                        <Link to="/our-services/tax-planning/">Tax Planning</Link>
                                    </li>
                                    <li className="p-1 md:p-0">
                                        <Link to="/our-services/financial-tools/">Financial Tools</Link>
                                    </li>
                                </ul>
                            </div>
                            <div className="footer-col-wrapper">
                                <h5 className="text-holborn-white" style={{ textDecoration: 'underline', textDecorationThickness: '2px', textUnderlineOffset: '5px' }}>
                                    Who We Are
                                </h5>
                                <ul className="text-holborn-white text-sm leading-7">
                                    <li className="p-1 md:p-0">
                                        <Link to="/who-we-are/about-us/">About Us</Link>
                                    </li>
                                    <li className="p-1 md:p-0">
                                        <Link to="/who-we-are/our-locations/">Our Locations</Link>
                                    </li>
                                    <li className="p-1 md:p-0">
                                        <Link to="/blog/">Our Blog</Link>
                                    </li>
                                </ul>
                            </div>
                            <div className="footer-col-wrapper">
                                <h5 className="text-holborn-white" style={{ textDecoration: 'underline', textDecorationThickness: '2px', textUnderlineOffset: '5px' }}>
                                    Contact Us
                                </h5>
                                <ul className="text-holborn-white text-sm leading-7">
                                    <li className="p-1 md:p-0">
                                        <Link to="/contact-us/">Get in touch</Link>
                                    </li>
                                    <li className="p-1 md:p-0">
                                        <Link to="/webinars/">Webinars</Link>
                                    </li>
                                </ul>
                            </div>
                            <div className="footer-col-wrapper">
                                <div
                                    ref={trustpilotWidgetRef}
                                    className="trustpilot-widget"
                                    data-locale="en-GB"
                                    data-template-id="53aa8807dec7e10d38f59f32"
                                    data-businessunit-id="58bff1ac0000ff00059e0e97"
                                    data-style-height="150px"
                                    data-style-width="100%"
                                    data-theme="dark">
                                    <a href="https://uk.trustpilot.com/review/holbornassets.com" target="_blank" rel="noreferrer noopener">Trustpilot</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-span-full md:pt-10">
                        <div className="grid justify-center">
                            <div className="footer-col-wrapper justify-center mx-auto">
                                <div className="footer-social-wrapper flex justify-center">
                                    <div className="footer-social-icon mx-4">
                                        <ExternalLink
                                            to="https://www.facebook.com/HolbornAssets/"
                                            target="_blank"
                                            rel=" noopener noreferrer"
                                            aria-label="Follow us on Facebook">
                                            <FaFacebook className="h-10 w-10 text-holborn-white" />
                                        </ExternalLink>
                                    </div>
                                    <div className="footer-social-icon mx-4">
                                        <ExternalLink to="https://twitter.com/holbornassets"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            aria-label="Follow us on Twitter">
                                            <BsTwitterX className="h-10 w-10 text-holborn-white" />
                                        </ExternalLink>
                                    </div>
                                    <div className="footer-social-icon mx-4">
                                        <ExternalLink
                                            to="https://www.linkedin.com/company/holborn-assets-llc/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            aria-label="Follow us on LinkedIn">
                                            <FaLinkedin className="h-10 w-10 text-holborn-white" />
                                        </ExternalLink>
                                    </div>
                                    <div className="footer-social-icon mx-4">
                                        <ExternalLink
                                            to="https://www.instagram.com/holbornassets/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            aria-label="Follow us on Instagram">
                                            <FaInstagram className="h-10 w-10 text-holborn-white" />
                                        </ExternalLink>
                                    </div>
                                    <div className="footer-social-icon mx-4">
                                        <ExternalLink
                                            to="https://www.youtube.com/@HolbornAssetsLtd"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            aria-label="Follow us on YouTube">
                                            <FaYoutube className="h-10 w-10 text-holborn-white" />
                                        </ExternalLink>
                                    </div>
                                </div>
                                <div className="footer-logo-wrapper flex justify-center py-8">
                                    <Logo logoType="HorizontalLogoWhite" />
                                </div>
                                <div className="footer-legal-wrapper flex justify-center">
                                    <p className="text-white">© {new Date().getFullYear()} Holborn Assets Ltd. All rights reserved.</p>
                                </div>
                                <div className="footer-legal-wrapper flex flex-wrap space-x-2 justify-center">
                                    <Link to="/privacy-notice/" className="text-white p-2 md:p-0">Privacy Notice</Link>
                                    <span className="text-white p-2 md:p-0">|</span>
                                    <Link to="/cookie-policy/" className="text-white p-2 md:p-0">Cookie Policy</Link>
                                    <span className="text-white p-2 md:p-0">|</span>
                                    <Link to="/complaints/" className="text-white p-2 p-2 md:p-0">Complaints</Link>
                                    <span className="text-white p-2 md:p-0">|</span>
                                    <Link to="/legal-notice/" className="text-white p-2 md:p-0">Legal Notice</Link>
                                    <span className="text-white p-2 md:p-0">|</span>
                                    <a href="/What-Are-Sustainable-Investments.pdf" className="text-white p-2 md:md:p-0" target="_blank" rel="noopener noreferrer">Sustainable Investments</a>
                                    <span className="text-white p-2 md:p-0">|</span>
                                    <Link to="/terms-of-use/" className="text-white p-2 md:p-0">Terms of Use</Link>
                                </div>
                            </div>
                            <p className='text-white text-center pt-4 text-sm'>Holborn’s Spanish office is passported via Holborn Insurance Agents, Sub Agents and Consultants (Cyprus) Ltd under the Ministry of Finance Insurance Companies Control Services licence No. 5228</p>
                        </div>
                    </div>
                </div>
            </Container>
        </footer>
    );
}

export default Footer;